// extracted by mini-css-extract-plugin
export default {"ctn":"ZYcurtain_ctn__AejZa","effectBox":"ZYcurtain_effectBox__PSQQp","box":"ZYcurtain_box__ufiJM","text":"ZYcurtain_text__EudFd","media":"ZYcurtain_media__JcNrs"};